//import React, { useState } from "react";
//import { useNavigate } from "react-router-dom";
//import { useSelector } from "react-redux";
//import { IsAllow } from "../../utils/allowHelper/AllowHelper";
//import Loading from "../../components/loading/Loading";
//import NoResults from "../../components/noResults/noResults";
//import Pagination from "../../components/pagination/Pagination";
//import { useTranslator } from "../../context/translator";
import ReportNav from "../../components/reportNav/ReportNav";
import NewCustomerReport from "../../components/reports/newCustomerReport/NewCustomerReport";

const NewCustomerReportPage = () => {
  /*
  const { user } = useSelector((state) => state.user);
  const { data: company } = useGetCompanyQuery(user.companyId);
  //const navigate = useNavigate();
  const [reportsData, setReportsData] = useState([]);
  // track page number
  const [page, setPage] = useState(1);
  // total number of records
  const [pageNumber, setPageNumber] = useState(0);
  // track API response time
  const [isLoading, setIsLoading] = useState(false);
  const [totalReports, setTotalReports] = useState(0);
  const { translate } = useTranslator();
  const [search] = useState("");
  //const [allow] = useState({ ...company?.allow });
*/

  return (
    <>
      <ReportNav>
        <NewCustomerReport />
      </ReportNav>
    </>
  );
};

export default NewCustomerReportPage;
